export default __webpack_public_path__ + "static/cmc-group-f-d78a1b1ff43ef5365939a5d6473e9f77.png";